// Get a universally unique identifier
var count = 0;
export default function uuid() {
  return "react-tabs-" + count++;
}
export function reset() {
  count = 0;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-tabs/esm/helpers/uuid.js
// module id = 395
// module chunks = 0